export default {
    name: "collectBillInvalidDetail",
	conditionData:'',
	mounted: function () {
      this.init();
	},
    data() {
        return {
            searchForm: {
                blCode:'',
                applyTime:'',
                sysAuditState :'',
                auditTime :'',
				page: 1,
				pageSize: 50
			},
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
			let conditionParam = this.$routerUtil.getParam();
			if(conditionParam && conditionParam.searchForm){
				conditionParam = conditionParam.searchForm;
			}
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
				this.$nextTick(() => {
					this.searchForm = conditionParam;
					this.doSearch();
				});
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
		doReset(){
			this.$nextTick(()=>{
				this.$refs.searchForm.resetFields();
			})
		},
		doSearch() {
			var that= this;
			const condition = new Object();
			condition.pageIndex = that.searchForm.page;
			condition.pageSize = that.searchForm.pageSize;
			condition.blNo = that.searchForm.blCode;
			if(that.searchForm.applyTime){
				condition.applyDayBeginTime = that.searchForm.applyTime[0];
				condition.applyDayEndTime = that.searchForm.applyTime[1];
			}
			if(that.searchForm.auditTime){
				condition.platformAuditDayBeginTime = that.searchForm.auditTime[0];
				condition.platformAuditDayEndTime = that.searchForm.auditTime[1];
			}
			condition.platformAuditResult = that.searchForm.sysAuditState;
			const param = this.$paramUtil.clearEmpty(condition);
			console.log(condition);
			this.$axios({
				method: "get",
				url: "api/billOfLadings/voidBillOfLadingApplyAll", // 接口地址
				params:param
				}).then(res => {
					this.tableData = res.data.resultData.rows;
					this.total = res.data.resultData.total;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: 'This is an error message',
						type: 'error',
						center: true
					});
				}); // 失败的返回
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
					center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
					center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
